
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/cloud-kitchen",
      function () {
        return require("private-next-pages/outlet/cloud-kitchen.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/cloud-kitchen"])
      });
    }
  